
import "/home/dispatchbutler/data/dispatchbutler/frontend/src/components/HeaderSearch/index.less?modules";
export default {"headerSearch": `headerSearch-pidJ5ed_`}
